
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/balances",
      function () {
        return require("private-next-pages/balances/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/balances"])
      });
    }
  